<template>
  <div class="new-popupbox">
    <div class="hanlder-box">
      <svg class="icon-svg popup-close" @click="close()">
        <use xlink:href="#icon-guanbi" />
      </svg>
    </div>
    <div class="lucidscreen"></div>
    <div class="box-content">
      <img class="cover" :src="certificat" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    certificat: String,
  },
  name: "show-certificat",
  data() {
    return {
     
    }
  },
  async mounted() {

  },

  methods: {
    //关闭
    close() {
      this.$emit("closeBox", true);
    }
  }
}
</script>

<style scoped lang="scss">
@import "./show-certificat.scss";
</style>